import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState("INR");
  const [conversionRate, setConversionRate] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const detectCurrency = async () => {
      try {
        const res = await fetch(`${import.meta.env.VITE_BACKEND_API_URL}/admin/get-user-ip`);
        const data = await res.json();

        const priceRes = await axios.get(`${import.meta.env.VITE_BACKEND_API_URL}/admin/get-web-usdprice`);
        const usdToInr = priceRes?.data?.data?.name || 85;

        if (data?.country_code === "IN") {
          setCurrency("INR");
          setConversionRate(1);
        } else {
          setCurrency("USD");
          setConversionRate(1 / usdToInr);
        }
      } catch (err) {
        console.error("Currency detection failed:", err);
        setCurrency("INR");
        setConversionRate(1);
      } finally {
        setLoading(false);
      }
    };

    detectCurrency();
  }, []);

  return (
    <CurrencyContext.Provider value={{ currency, conversionRate, loading }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);